import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";
import { Toaster } from "sonner";
import "react-toastify/dist/ReactToastify.css";
import Sidebar from "./Components/Navigate/Sidebar";
import Navbar from "./Components/Navigate/Navbar";
import DealDashboard from "./Components/Dashboard/DealDashboard";
import LeadDashboard from "./Components/Dashboard/LeadDashboard";
import LoginPage from "./Components/LoginPage/LoginPage";
import AllSalesPerson from "./Components/Sales Person/AllSalesPerson";
import CreateSalesPerson from "./Components/Sales Person/CreateSalesPerson";
import SalesVisit from "./Components/Sales Person/SalesVisit";
import Outlets from "./Components/Outlets/OutletManager";
import Dashboard from "./Components/SuperAdmin/Dashboard";
import BusinessReports from "./Components/Resturant Reports/RestaurantReports";
import UnAuthorizedPage from "./Components/UnAuthorizedPage";
import AllProducts from "./Components/Products/AllProducts";
import Services from "./Components/Services/Services";

const readSession = () => {
  try {
    const raw = sessionStorage.getItem("userData");
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

const isSessionValid = (session) => {
  if (!session?.isAuthenticated) return false;
  if (session?.expiresAt) {
    const exp = new Date(session.expiresAt).getTime();
    if (Number.isFinite(exp) && Date.now() >= exp) return false;
  }
  return true;
};

const ProtectedRoute = ({ children }) => {
  const session = readSession();
  return isSessionValid(session) ? children : <Navigate to="/login" replace />;
};

const GuestRoute = ({ children }) => {
  const session = readSession();
  return isSessionValid(session) ? <Navigate to="/" replace /> : children;
};

function AppWrapper() {
  const navigate = useNavigate();
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [isAuthorized, setIsAuthorized] = useState(null);

  // Session validation
  useEffect(() => {
    if (localStorage.getItem("userData")) {
      localStorage.removeItem("userData");
    }

    const session = readSession();
    if (!isSessionValid(session) && location.pathname !== "/login") {
      sessionStorage.removeItem("userData");
      navigate("/login", { replace: true });
    }
  }, [navigate, location.pathname]);

  const handleAuthorizationChange = (authorized) => {
    setIsAuthorized(authorized);

    if (authorized === false) {
      navigate("/unauthorized", { replace: true });
    }
  };

  const handleSubItemClick = (subItem) => {
    if (subItem.path) navigate(subItem.path);
  };

  return (
    <>
      <Routes>
        <Route
          path="/login"
          element={
            <GuestRoute>
              <LoginPage onLogin={() => navigate("/")} />
            </GuestRoute>
          }
        />

        <Route path="/unauthorized" element={<UnAuthorizedPage />} />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <div className="flex bg-[#FBFBFC] h-screen">
                <Sidebar
                  sidebarOpen={sidebarOpen}
                  setSidebarOpen={setSidebarOpen}
                  onSubItemClick={handleSubItemClick}
                  onAuthorizationChange={handleAuthorizationChange}
                />
                <div
                  className={`flex-1 flex flex-col transition-all duration-300 ${
                    sidebarOpen ? "ml-60" : "ml-16"
                  }`}
                >
                  <Navbar
                    sidebarOpen={sidebarOpen}
                    setSidebarOpen={setSidebarOpen}
                  />
                  <main className="flex-1 p-2 bg-[#FBFBFC] overflow-auto">
                    <Routes>
                      <Route
                        path="/"
                        element={<Navigate to="/business-reports" replace />}
                      />
                      <Route
                        path="/deal-dashboard"
                        element={<DealDashboard />}
                      />
                      <Route
                        path="/lead-dashboard"
                        element={<LeadDashboard />}
                      />
                      <Route
                        path="/create-sales-person"
                        element={<CreateSalesPerson />}
                      />
                      <Route
                        path="/all-sales-person"
                        element={<AllSalesPerson />}
                      />
                      <Route path="/sales-visit" element={<SalesVisit />} />
                      <Route path="/outlets" element={<Outlets />} />
                      <Route path="/dashboard" element={<Dashboard />} />
                      <Route
                        path="/restaurant-reports"
                        element={<BusinessReports />}
                      />
                      <Route path="/all-product" element={<AllProducts />} />
                      <Route path="/services" element={<Services/>}/>
                      <Route
                        path="*"
                        element={<Navigate to="/restaurant-reports" replace />}
                      />
                    </Routes>
                  </main>
                </div>
              </div>
            </ProtectedRoute>
          }
        />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toaster richColors position="top-right" />
    </>
  );
}

export default function App() {
  return (
    <Router>
      <AppWrapper />
    </Router>
  );
}
